import React, { useEffect } from "react"
import { Grid } from "@mui/material"
import { useValidatorSeeker } from "@ui-seeker/app"
import { array, object } from "yup"

import { AppProvidersAutocomplete, AppTiersAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { BACKEND_APIS } from "@constants"


export default function Providers({ tiersLabel = "Tiers", providersLabel = "Providers" }) {

	const {
		dataInfo: providers, setDataInfo: setProviders
	} = useAlertsDataInfo(alertsDrawerData.peek().mainProvider || [])

	const { dataInfo: tiers, setDataInfo: setTiers } = useAlertsDataInfo(alertsDrawerData.peek().mainTiers || [])

	const {
		dataInfo: providersByTiers, setDataInfo: setProvidersByTiers
	} = useAlertsDataInfo(alertsDrawerData.peek().providersByTiers || [])

	const { errors, isValid } = useValidatorSeeker({ providers: providers.value }, object({
		providers: array().min(1, 'Must select at least one provider')
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, providers: isValid }
	}, [JSON.stringify(errors)])

	return <Grid container spacing={2}>
		<Grid item xs={6}>
			<AppTiersAutocomplete
				multiple
				value={tiers.value}
				label={tiersLabel}
				onChange={e => {
					setProviders(e.target.value.reduce((acc, curr) => [...acc, ...providersByTiers.value.find(t => t.key === curr).providers], []), 'mainProvider')
					setTiers(e.target.value, 'mainTiers')
				}}
				onFinishAjax={options => {
					setProvidersByTiers(options.map(t => ({
						key: t.value, providers: t.providers
					})), 'providersByTiers')
				}}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
			/>
		</Grid>
		<Grid item xs={6}>
			<AppProvidersAutocomplete
				value={providers.value}
				label={providersLabel}
				onChange={e => setProviders(e.target.value, 'mainProvider')}
				disabled={!!tiers.value.length}
				error={errors.providers}
			/>
		</Grid>
	</Grid>

}